module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAATElEQVRYw2PgnxvRAMT/Bwg3MAyg5WA86oBRB+B0ALXB0HUAseKkmjPqgKHjgNFcMJoGRh0wmgtG08CoA0ZuLhhtFY86gJ4OGNDuOQCbidQ0cz6vGQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/assets/file-icons/sheet.png
// module id = 1619
// module chunks = 0